import React from 'react';

import { RenderLeafProps } from 'slate-react';

const Leaf = (props: RenderLeafProps) => {
    return <span {...props.attributes}>{props.children}</span>;
};

export default Leaf;
